const analytics = {

  /**
   * Pushes data to GTM datalayer
   *
   * @param {Object} data - Data to send
   */
  push(data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  },

  /**
   * Pushes data added in Stage scriptlets to GTM datalayer.
   * Add data to window.RAUTE.dataLayer in Stage
   * if it needs to be sent after cookie consent is submitted.
   */
  triggerDelayedDataLayer() {
    window.RAUTE.dataLayer.forEach(item => this.push(item));
    window.RAUTE.dataLayer.splice(0, window.length);
  }
};

export default analytics;
